import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ArrowUp } from "lucide-react";
 * // Use <ArrowUp /> instead
 */
export const ArrowUpIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M8.067 14h7.865a.5.5 0 0 0 .385-.82l-3.933-4.72a.5.5 0 0 0-.768 0l-3.933 4.72a.5.5 0 0 0 .384.82Z"
  />
);
